import { Injectable } from '@angular/core';
import { NetworkManager } from 'src/app/managers/network/network.manager';
import { HttpHeaders } from '@angular/common/http';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { CQWebappApi } from 'src/app/enums/network/request/cqwebapp/cqwebappApi.enum';

@Injectable({
  providedIn: 'root',
})
export class TimestableRequest {
  constructor(private network: NetworkManager) {}

  /**
   *
   * @param token
   * @param deviceId
   */
  getDevice(token: string, deviceId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.GET_DEVICE_TIME;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.DEVICE_ID, deviceId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   */
  getService(token: string, serviceId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.GET_SERVICE_TIME;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SERVICE_ID, serviceId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }
}
